import { mapCategoryToColor, mapCategoryToIcon } from '@/utils/categoryUtils';

import { CategoryComplianceSquare } from '@/icons';

interface PlanCardCategoryIconProps {
  category: string;
  disabled: boolean;
  /**
   * This is a special case for showing a
   * different icon for compliance plans in a disabled state.
   */
  disabledCompliance?: boolean;
}

const PlanCardCategoryIcon: React.FC<PlanCardCategoryIconProps> = ({
  category,
  disabled,
  disabledCompliance = false,
}) => (
  <div
    className="flex h-auto max-h-screen w-20 shrink-0 items-center justify-center self-auto rounded-l-[inherit]"
    style={{
      background: disabled
        ? 'var(--color-grayscale-gray3)'
        : mapCategoryToColor(category),
    }}
  >
    {disabledCompliance ? (
      <CategoryComplianceSquare />
    ) : (
      mapCategoryToIcon(category)
    )}
  </div>
);

export default PlanCardCategoryIcon;
